/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'

import ProductContent from '../../../../pages/product-detail/partials/product-content'

export const PDProductDetail = () => {
    return <ProductContent />
}

export default PDProductDetail
